class FeaturedCollection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    window.loadSwiper.then(({ Swiper }) => {
      this.Swiper = Swiper;

      this._initCarousel();
    });
  }

  disconnectedCallback() {}

  _initCarousel() {
    const swiperParams = {
      slidesPerView: "auto",
      spaceBetween: 24,
      speed: 700,
      resistanceRatio: 0.85,
      navigation: {
        nextEl: this.querySelector("[data-navigation-next]"),
        prevEl: this.querySelector("[data-navigation-previous]"),
      },
      breakpoints: {
        1024: {
          spaceBetween: 40,
        },
      },
    };

    this.gallerySwiper = new this.Swiper(
      this.querySelector(".featured-collection__products-wrapper"),
      swiperParams,
    );
  }
}

if (!customElements.get("featured-collection")) {
  customElements.define("featured-collection", FeaturedCollection);
}
